import React from 'react';
import { Edit } from 'react-admin';

import VendorForm from './VendorForm';
import ErrorBoundary from '../ErrorBoundary';

const VendorEdit = props => (
    <ErrorBoundary>
        <Edit {...props} title="Edit Supply Vendor" undoable={false}>
            <VendorForm redirect="list" />
        </Edit>
    </ErrorBoundary>
);

export default VendorEdit;
